import React, { FC } from 'react'
import inEU from '@segment/in-eu'
import { ConsentManagerBuilder } from '@segment/consent-manager'
import { useCookieBanner } from '../../lib/useCookieBanner'

type BannerContentComponent = FC<{
  saveConsent: (newPreferences: boolean) => void
  setCTA: (cta: string) => void
}>

// Allow to set the cookie domain and make the consent cookie available to all subdomains
const COOKIE_CONSENT_DOMAIN = process.env.COOKIE_CONSENT_DOMAIN

const CookieBannerWrapper: FC<{
  saveConsent: (newPreferences: boolean) => void
  preferences: Record<string, unknown>
  BannerContent: BannerContentComponent
}> = ({ saveConsent, preferences, BannerContent }) => {
  const { open, setCTA } = useCookieBanner(preferences)
  return open ? (
    <BannerContent saveConsent={saveConsent} setCTA={setCTA} />
  ) : null
}

export const CookieConsent: FC<{
  segmentWriteKey: string | undefined
  BannerContent: BannerContentComponent
}> = ({ segmentWriteKey, BannerContent }) => {
  return segmentWriteKey ? (
    <ConsentManagerBuilder
      writeKey={segmentWriteKey}
      cookieDomain={COOKIE_CONSENT_DOMAIN}
      shouldRequireConsent={inEU}
      defaultDestinationBehavior="imply"
    >
      {({ saveConsent, preferences }) => (
        <CookieBannerWrapper
          saveConsent={saveConsent}
          preferences={preferences}
          BannerContent={BannerContent}
        />
      )}
    </ConsentManagerBuilder>
  ) : null
}

export default CookieConsent
